// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSourceOutageNotice-modulenotice___HHho GretaAIChatLimitNotice-modulenotice__U4wMw";
export { _1 as "notice" }
